import React from "react";
import { useMantineTheme, Box } from '@mantine/core';

const THPlain = ({ stateCaption, stateCaptionNoWrap = true, stateCaptionAlign = 'left' }) => {

    const theme = useMantineTheme();

    return (
        <th
            style={{
                backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[6],
                whiteSpace: stateCaptionNoWrap ? 'nowrap' : 'normal',
                textAlign: stateCaptionAlign,
                paddingRight: '0px'
            }}
        >
            <Box
                className="wrapperContentTH"
                pr='sm'
            >
                {stateCaption}
            </Box>
        </th>
    )
}

export default React.memo(THPlain);